import B2bStoreInvite from "../../components/B2bStoreInvite/B2bStoreInvite";
import OrdersSegment from "../../components/OrdersSegment/OrdersSegment";
import PageWrapper from "../PageWrapper/PageWrapper";

function OrdersPage() {

  return (
    <PageWrapper>
      <>
        <B2bStoreInvite />
        <OrdersSegment />
      </>
    </PageWrapper>
  );
}

export default OrdersPage;
